import { render, staticRenderFns } from "./RentabilidadeFornecedores.vue?vue&type=template&id=249c77b2&scoped=true"
import script from "./RentabilidadeFornecedores.vue?vue&type=script&lang=js"
export * from "./RentabilidadeFornecedores.vue?vue&type=script&lang=js"
import style0 from "./RentabilidadeFornecedores.vue?vue&type=style&index=0&id=249c77b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249c77b2",
  null
  
)

export default component.exports